import "./KeyFeatures.scss";
import AiImg from "../../assets/images/key-features/ai.png";
import GlobeImg from "../../assets/images/key-features/globe.png";
import CogsImg from "../../assets/images/key-features/cogs.png";
import ShieldImg from "../../assets/images/key-features/shield.png";
import NoCodeImg from "../../assets/images/key-features/no-code.png";

const features = [
	{
		image: AiImg,
		alt: "AI",
		title: "Autonomous AI Agents",
		description:
			"Go beyond simple assistance; our AI handles tasks independently.",
		className: "",
		width: 193,
		height: 188,
	},
	{
		image: GlobeImg,
		alt: "Globe",
		title: "Seamless Web3 Integration",
		description:
			"Privacy-focused, decentralized AI built for blockchain innovation.",
		className: "right-cut",
		width: 167,
		height: 156,
	},
	{
		image: CogsImg,
		alt: "Cogs",
		title: "Full Automation",
		description: "Automate websites, smart contracts, research, and more.",
		className: "",
		width: 164,
		height: 154,
	},
	{
		image: ShieldImg,
		alt: "Shield",
		title: "Proactive Intelligence",
		description:
			"AI that anticipates needs, provides solutions, and adapts.",
		className: "right-cut",
		width: 148,
		height: 150,
	},
	{
		image: NoCodeImg,
		alt: "No Code",
		title: "User-Friendly & No-Code",
		description: "No technical skills? No problem. Vernus AI makes complex processes.",
		className: "both-cut",
		width: 234,
		height: 234,
	},
];

export default function KeyFeatures() {
	return (
		<div className="key-features" id="features">
			<div className="key-features-content-wrapper content-wrapper-lg">
				<div className="key-features-content">
					<h3 className="key-features-title" data-aos="fade-up">
						<span className="title-txt">Key Features</span>
					</h3>
					<p
						className="key-features-desc"
						data-aos="fade-up"
						data-aos-delay="100"
					>
						The problem with traditional AI in Web3 is its reactive
						nature, requiring constant input. Vernus AI changes the
						game with proactive, self-learning AI agents that act
						autonomously, freeing you from repetitive tasks.
					</p>
					<div className="key-features-row">
						{features.map((feature, index) => (
							<div className="key-features-col" key={index}>
								<div
									className={`key-feature-card ${feature.className}`}
									data-aos="zoom-in"
								>
									<div className="cut-border" />
									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={feature.image}
												alt={feature.alt}
												width={feature.width}
												height={feature.height}
											/>
										</div>
										<div className="key-feature-content">
											<h4 className="key-feature-title">
												{feature.title}
											</h4>
											<p className="key-feature-desc">
												{feature.description}
											</p>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
